module.exports = __webpack_public_path__ + "static/media/furniture.ca62972f.jpg";